module.exports = __webpack_public_path__ + "img/consumo-responsabile-01.b1d0ebf0.svg";